/**
 * Shared constants for components
 */

export const iconStyle = {
  fontSize: '14px',
  color: '#000',
  cursor: 'pointer',
  transition: 'color 0.3s ease',
  background: '#A0D911',
  borderRadius: '50%',
  minWidth: '24px',
  minHeight: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #7CB305',
};
